/* Alex Lexington - INDULGE wishlist (no app, no backend).
   Per-device localStorage, so it works for guests and adds no third-party
   script. It does NOT follow a customer across devices; that upgrade means
   persisting through al-business-api.
   Loaded only by sections/al-wishlist.liquid -> INDULGE surfaces only. */
(function () {
  'use strict';

  var KEY = 'al:indulge:wishlist:v1';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return []; // private mode or corrupt value - degrade, never throw
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
      return true;
    } catch (e) {
      return false;
    }
  }

  function has(id) {
    return read().some(function (item) { return item.id === id; });
  }

  function toggle(entry) {
    var list = read();
    var next = list.filter(function (item) { return item.id !== entry.id; });
    var removed = next.length !== list.length;
    if (!removed) next.unshift(entry);
    write(next);
    document.dispatchEvent(new CustomEvent('al:wishlist:change', { detail: { count: next.length } }));
    return !removed;
  }

  function label(saved) {
    return saved ? 'Saved to wishlist' : 'Add to wishlist';
  }

  function hydrate(mount) {
    if (mount.dataset.alWlReady) return;

    var entry = {
      id: mount.dataset.productId,
      handle: mount.dataset.productHandle,
      title: mount.dataset.productTitle,
      price: mount.dataset.productPrice,
      image: mount.dataset.productImage,
      url: mount.dataset.productUrl
    };
    if (!entry.id) return;

    mount.dataset.alWlReady = '1';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'al-wl__btn';
    btn.setAttribute('aria-pressed', String(has(entry.id)));

    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('class', 'al-wl__icon');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M12 20.5S3.5 15 3.5 9.2A4.7 4.7 0 0 1 12 6.6a4.7 4.7 0 0 1 8.5 2.6c0 5.8-8.5 11.3-8.5 11.3z');
    icon.appendChild(path);

    var text = document.createElement('span');
    text.className = 'al-wl__label';
    text.textContent = label(has(entry.id));

    btn.appendChild(icon);
    btn.appendChild(text);

    var live = document.createElement('span');
    live.className = 'al-wl__sr';
    live.setAttribute('aria-live', 'polite');

    btn.addEventListener('click', function () {
      var saved = toggle(entry);
      btn.setAttribute('aria-pressed', String(saved));
      text.textContent = label(saved);
      live.textContent = saved
        ? entry.title + ' added to your wishlist'
        : entry.title + ' removed from your wishlist';
      btn.dataset.justSaved = '1';
      window.setTimeout(function () { delete btn.dataset.justSaved; }, 260);
    });

    mount.appendChild(btn);
    mount.appendChild(live);
  }

  function renderPage(root) {
    var list = read();
    var grid = root.querySelector('[data-al-wishlist-grid]');
    var empty = root.querySelector('[data-al-wishlist-empty]');
    if (!grid || !empty) return;

    grid.textContent = '';
    empty.hidden = list.length > 0;
    grid.hidden = list.length === 0;

    list.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'al-wlp__card';

      var a = document.createElement('a');
      a.href = item.url || ('/products/' + item.handle);

      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        a.appendChild(img);
      }

      var name = document.createElement('span');
      name.className = 'al-wlp__name';
      name.textContent = item.title || item.handle;
      a.appendChild(name);
      li.appendChild(a);

      if (item.price) {
        var price = document.createElement('div');
        price.className = 'al-wlp__price';
        price.textContent = item.price;
        li.appendChild(price);
      }

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'al-wlp__remove';
      remove.textContent = 'Remove';
      remove.addEventListener('click', function () {
        toggle({ id: item.id });
        renderPage(root);
      });
      li.appendChild(remove);

      grid.appendChild(li);
    });
  }

  function init() {
    var mounts = document.querySelectorAll('[data-al-wishlist-mount]');
    Array.prototype.forEach.call(mounts, hydrate);
    var page = document.querySelector('[data-al-wishlist-page]');
    if (page) renderPage(page);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme swaps product markup on variant change; re-hydrate any new mount.
  document.addEventListener('variant:change', init);
})();
